import React from 'react'
import { Document, Page, View, Text, StyleSheet, Link, Image } from '@react-pdf/renderer'
import moment from 'moment'

const styles = StyleSheet.create({
    DescrImage: {
      width: '100%',
      borderLeft: '4px solid #4e85bd',
      padding: '10px',
      fontSize: '10px',
    },
    Image: {
      width: '100px',
      height: '100px',
    },
    page: {
      // fontFamily: config.fontFamily,
      // fontSize: config.normalFontSize,
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginBottom: 5,
    },
    containerTable: {
      borderStyle: 'solid',
      padding: '0 10',
    },
    row: {
      flexDirection: 'row',
      border: '1px solid black',
    },
    cellHead: {
      flex: 1,
      border: '1px solid black',
      padding: 5,
      fontSize: '12px',
      backgroundColor: 'lightgrey',
    },
    cell: {
      flex: 1,
      border: '1px solid black',
      padding: 5,
      fontSize: '10px',
    },
    cardFlag: {
      color: '#fff',
      backgroundHover: 'db4912',
      width: 100,
      height: 30,
      size: 'md',
      border: '1px solid black',
      fontSize: '10px',
      fontWeight: 'bold',
      // textAlign: 'center',
      margin: '0 2px',
      padding: '8px',
    },
    category: {},
    details: {},
    image: {
      height: '110%',
      marginLeft: -10,
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      height: '100%',
    },
    title: {
      fontWeight: 'bold',
      marginRight: 5,
      marginBottom: 10,
      marginTop: 20,
      padding: '0 10px',
    },
    label: {
      flex: 1,
      color: 'white',
      fontSize: '12px',
      marginBottom: 3,
      fontWeight: 'bold',
    },
  })
const PDFJump = ({ dataJump, filter }) => {
  const uniqueSiteNames = Array.from(new Set(dataJump.map(item => item.siteName)));
  const selectedSiteName = uniqueSiteNames[0] || '';
  const filteredData = dataJump.reduce((accumulator, currentValue) => {
    const currentDate = currentValue.date.split(' ')[0];
    const existingDateIndex = accumulator.findIndex(item => item.date === currentDate);
    if (existingDateIndex !== -1) {
      return accumulator;
    }
    accumulator.push({
      date: currentDate,
      sum: currentValue.sum
    });

    return accumulator;
    }, []);

  const filteredDataMonth = dataJump.reduce((accumulator, currentValue) => {
    const currentMonthYear = currentValue.date.split('-').slice(0, 2).join('-');
    const existingMonthYearIndex = accumulator.findIndex(item => item.date === currentMonthYear);
    if (existingMonthYearIndex !== -1) {
      return accumulator;
    }
    accumulator.push({
      date: currentMonthYear,
      sum: currentValue.sum
    });

    return accumulator;
    }, []);

  const filteredDataYear = dataJump.reduce((accumulator, currentValue) => {
    const currentYear = currentValue.date.split('-')[0];
    const existingYearIndex = accumulator.findIndex(item => item.date === currentYear);
    if (existingYearIndex !== -1) {
      return accumulator;
    }
    accumulator.push({
      date: currentYear,
      sum: currentValue.sum
    });
    return accumulator;
    }, []);
  return (
    <Document>
        <Page size="A4" style={styles.page} wrap>
        <View style={{ display: 'flex', flexDirection: 'row', width: '100%', backgroundColor: 'grey', padding: 20, }} >
            <View style={{ flex: 2 }}>
              <Text style={{ fontWeight: 'bold', marginRight: 5, marginBottom: 5, marginTop: 15, color: 'white', }} >
                JUMLAH PENGGUNA JPO
              </Text>
              <Text style={{ fontWeight: 'bold', marginRight: 5, color: 'white', }} >
                {selectedSiteName}
              </Text>
              {filter === 'daily' ? (
                <>
                  {filteredData.map((item, index) => (
                    <View key={index}>
                      <Text className="col-xl-6" style={{ color: 'white'}}>Periode {moment(item.date).format('DD MMMM YYYY')}</Text>
                    </View>
                  ))}
                </>
                ): null}
                {filter === 'monthly' ? (
                <>
                  {filteredDataMonth.map((item, index) => (
                    <View key={index}>
                      <Text className="col-xl-6" style={{ color: 'white'}}>Periode {moment(item.date).format('MMMM YYYY')}</Text>
                    </View>
                  ))}
                </>
                ): null}
                {filter === 'yearly' ? (
                <>
                  {filteredDataYear.map((item, index) => (
                    <View key={index}>
                      <Text className="col-xl-6" style={{ color: 'white'}}>Periode {moment(item.date).format('YYYY')}</Text>
                    </View>
                  ))}
                </>
                ): null}
            </View>
          </View>
            <View style={{ flex: 2, paddingTop: '10px' }}>
              <View style={styles.containerTable}>
                <View style={styles.row}>
                  <Text style={styles.cellHead}>Tanggal</Text>
                  {filter === 'daily' ? (
                      <Text style={styles.cellHead}>Waktu</Text>
                  ): null}
                  <Text style={styles.cellHead}>Jumlah</Text>
                </View>
                {dataJump.map((key, index) => (
                  <View style={styles.row} key={index}>
                    {filter === 'yearly' ? (
                      <Text style={styles.cell}>{moment(key.date).format('MMMM YYYY')} </Text>
                    ) : 
                      <Text style={styles.cell}>{moment(key.date).format('DD MMMM YYYY')} </Text> 
                    }
                    {filter === 'daily' ? (
                        <Text style={styles.cell}>{moment(key.date).format('HH:mm:ss')}</Text>
                    ): null}
                    <Text style={styles.cell}>{key.sum}</Text>
                  </View>
                ))}
              </View>
          </View>
        </Page>
    </Document>
  )
}

export default PDFJump